<template>
  <footer class="app-footer">
    NDrive Navigation Systems SA &copy; 2017.
    <span class="float-right"><span class="small text-muted"> {{$package.version}}</span></span>
  </footer>
</template>
<script>
export default {
  name: 'footer'
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue